import React from "react";
import { KEY_ENTER, ROLES_ALL, ROUTES_PATIENT, ROUTES_PATIENTS, ROUTES_SEARCH_OMIM } from "../../utils/constants";
import { makeStyles } from "@material-ui/styles";
import { useIntl } from "react-intl";
import { useNavigate } from "react-router-dom";
import ButtonIconComponent from "../common/ButtonIconComponent";
import iconSearch from "../../images/gen/icon-search-blue.svg";
import iconUser from "../../images/gen/icon-user.svg";
import iconPlusUser from "../../images/gen/icon-plus-user-blue.svg";
import withAuthorization from "../common/auth/withAuthorization";
import SearchBarComponent from "../common/SearchBarComponent";
import { useDispatch, useSelector } from "react-redux";
import { storePatientDataActionCreator, storeSearchPatientIdActionCreator } from "../../reducers/patientState";
import { originNoPatientListActionCreator } from "../../reducers/commonState";

const useStyles = makeStyles(() => ({
  divContainer: {
    display: "grid",
    gap: "2rem",
    justifyItems: "center",
    alignContent: "center",
    height: "100%",
    padding: "1rem",
  },
  buttonContainer: {
    display: "grid",
    width: "100%",
    gap: "1rem",
    gridTemplateColumns: "repeat(auto-fit, 200px)",
    justifyContent: "center",
  },
}));

function LandingComponent() {
  const navigate = useNavigate();
  const classes = useStyles();
  const intl = useIntl();
  const dispatch = useDispatch();

  const searchPatientId = useSelector((state) => state.patient.searchPatientId);

  const handleNavigateTo = (route) => navigate(route);

  const handleTextChange = (event) => {
    localStorage.setItem("genome-patient-id", event.target.value);
    dispatch(storeSearchPatientIdActionCreator(event.target.value));
  };

  const handleSearchPatientKey = (event) => {
    const { key } = event;
    key === KEY_ENTER && searchPatientId && handleGoToEditUser();
  };

  const handleGoToEditUser = () => {
    localStorage.setItem("genome-new-patient", JSON.stringify(false));
    dispatch(originNoPatientListActionCreator());
    handleNavigateTo(ROUTES_PATIENT);
  };

  const handleGoToPatientList = () => {
    handleNavigateTo(ROUTES_PATIENTS);
  };

  const handleGoToAddUser = () => {
    localStorage.removeItem("genome-patient-id");
    dispatch(storeSearchPatientIdActionCreator(""));
    dispatch(storePatientDataActionCreator(null));
    localStorage.setItem("genome-new-patient", JSON.stringify(true));
    handleNavigateTo(ROUTES_PATIENT);
  };

  return (
    <div className={classes.divContainer}>
      <SearchBarComponent
        handleChange={handleTextChange}
        handleKeyDown={handleSearchPatientKey}
        handleClick={handleGoToEditUser}
        placeholder={"searchPatientComponent.input_placeholder"}
        disabled={!searchPatientId}
      />
      <div className={classes.buttonContainer}>
        <ButtonIconComponent
          title={intl.formatMessage({ id: "landingComponent.searchOmim" })}
          icon={iconSearch}
          action={() => handleNavigateTo(ROUTES_SEARCH_OMIM)}
        />
        <ButtonIconComponent
          title={intl.formatMessage({ id: "landingComponent.seePatients" })}
          icon={iconUser}
          action={handleGoToPatientList}
          secondary
        />
        <ButtonIconComponent
          title={intl.formatMessage({ id: "landingComponent.addPatient" })}
          icon={iconPlusUser}
          action={handleGoToAddUser}
        />
      </div>
    </div>
  );
}

export default withAuthorization(ROLES_ALL)(LandingComponent);
